export const TESTIMONIALS_PAGE_COUNT = 3;
export const TESTIMONIALS_MIN_RATING = 4;
